import { render, staticRenderFns } from "./BranchOverview.vue?vue&type=template&id=953379cc&"
import script from "./BranchOverview.vue?vue&type=script&lang=js&"
export * from "./BranchOverview.vue?vue&type=script&lang=js&"
import style0 from "./BranchOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports